import config from 'react-global-configuration';
import cachedConfig from './config-cached.json';

config.set(cachedConfig);